export const getUserNameWithConditionalCheck = (
  displayName: string,
  firstName: string,
  lastName: string,
  email?: string
) => {
  if (email)
    return displayName
      ? `${displayName} ${email ? "(" + email + ")" : ""}`
      : `${firstName || ""} ${lastName || ""} ${email ? "(" + email + ")" : ""}`;
  return displayName ? displayName : `${firstName || ""} ${lastName || ""}`;
};

export const getResolvedUserDisplayName = (user: any) => {
  if (!user?.displayName && !user?.firstName && !user?.lastName) return "";
  return getUserNameWithConditionalCheck(user?.displayName, user?.firstName, user?.lastName);
};

export const getOwnersDisplayList = (ownerCodes: string[] = [], userDetailsList: any[] = []) => {
  return (ownerCodes || []).map((code: string) => {
    const user = userDetailsList?.find((item: any) => item?.hltId === code);
    return { code, name: getResolvedUserDisplayName(user) };
  });
};
